declare global {
  interface Window {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[] };
  }
}

export function initClarity() {
  const clarityProjectId: string = import.meta.env.VITE_CLARITY_PROJECT_ID;

  if (window.clarity) return;

  window.clarity = function (...args: unknown[]) {
    (window.clarity!.q = window.clarity!.q || []).push(args);
  };

  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.clarity.ms/tag/" + clarityProjectId;
  document.head.appendChild(s);
}
